const SETTINGS_pub = {
 
    priceSearch:"https://lekeo.pl/ep/pricesearch?",
    search_url : "https://lekeo.pl/ep/lekName?v=",
    shipment: "http://lekeo.pl/ep/shipment?"
}
const SETTINGS_priv = {
    
    priceSearch:"http://localhost:3002/pricesearch?",
    search_url : "http://localhost:3002/lekName?v=",
    shipment: "http://localhost:3002/shipment?",
    host:'localhost',
    port: 3002, 
}

const SETTINGS = SETTINGS_pub

export default SETTINGS

